import React from "react";
import {NavDispatchContext} from '../providers';

function useDispatchNav() {
    return React.useContext(NavDispatchContext);
}

export {useDispatchNav}
